import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { ParagraphIcon } from '@calendly/ui/components/icons';
import { Item } from '@calendly/ui/components/menu';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { ViewportDropdownMenu } from 'components/core/viewport_dropdown_menu';
import { SORT_OPTIONS } from '../constants';
const containerCss = "c14tnmd7";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const buttonCss = "bggoui6";
const Button = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(buttonCss, props.className)} />);

// i18n-tasks-use I18n.t('publisher.meetings.search.results.sort.most_recent')
// i18n-tasks-use I18n.t('publisher.meetings.search.results.sort.least_recent')
// i18n-tasks-use I18n.t('publisher.meetings.search.results.sort.best_match')
export const SortSelector = ({
  value,
  onChange
}) => {
  const [toggle, Dropdown, isOpen] = useDropdown();
  const isPhone = useDeviceType('isPhone');
  return <Container>
      <Button aria-label={I18n.t('publisher.meetings.search.results.sort.sort_by')} aria-expanded={isOpen} onClick={toggle}>
        <ParagraphIcon spacingRight={4} />
        {!isPhone && <>
            <BodyText color="muted">
              {I18n.t('publisher.meetings.search.results.sort.sort_by')}
              {': '}
            </BodyText>
            <BodyText>
              {I18n.t(`publisher.meetings.search.results.sort.${value.toLowerCase()}`)}
            </BodyText>
          </>}
      </Button>
      <Dropdown>
        <ViewportDropdownMenu>
          {SORT_OPTIONS.map(option => <Item key={option} onClick={() => onChange(option)}>
              <BodyText>
                {I18n.t(`publisher.meetings.search.results.sort.${option.toLowerCase()}`)}
              </BodyText>
            </Item>)}
        </ViewportDropdownMenu>
      </Dropdown>
    </Container>;
};

require("./sort_selector.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./sort_selector.js");